module.exports = __webpack_public_path__ + "img/private-napolimania-pasta-2.b96f267d.jpg";